// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hM_Z","colMin":"styles_colMin__3TbzP"};